import type { ReactNode } from "react";
import { LockIcon } from "./icons";
import { cn, focusRing } from "./utils";

export function DayDivider({ children }: { children: ReactNode }) {
  return (
    <div className="mb-1.5 self-center rounded-full bg-line px-3 py-1 text-xs font-semibold text-ink-secondary">
      {children}
    </div>
  );
}

// Group events such as "Daniel added Lena".
export function SystemLine({ children }: { children: ReactNode }) {
  return (
    <p className="m-0 mb-1.5 self-center rounded-full bg-line px-3 py-1 text-center text-xs font-semibold text-ink-secondary">
      {children}
    </p>
  );
}

export function EncryptionNotice({
  children = "Messages and calls are end-to-end encrypted. Tap to learn more.",
  onClick,
}: {
  children?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "mb-2 flex max-w-[300px] cursor-pointer items-center gap-2 self-center rounded-field border border-line bg-surface px-3.5 py-[9px] text-left text-[12.5px] leading-[1.35] text-ink-secondary",
        focusRing,
      )}
    >
      <LockIcon size={14} strokeWidth={2.2} className="flex-none text-blue" />
      {children}
    </button>
  );
}
